import {
  NgClass,
  NgOptimizedImage
} from '@angular/common';
import {
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { emulateClick } from '../../../core/a11y';
import { ProductsComponent } from '../../../products/products.component';
import { AutoCloseDirective } from '../../../shared/directives/auto-close.directive';
import { CenterService } from '../../../shared/services/center.service';
import { ProductService } from '../../../shared/services/product.service';
import { SelectionService } from '../../../shared/services/selection.service';

@Component({
  selector: 'app-refill',
  templateUrl: 'refill.component.html',
  imports: [
    NgxTolgeeModule,
    AutoCloseDirective,
    NgOptimizedImage,
    ProductsComponent,
    NgClass,
  ]
})
export class RefillComponent {
  selectionService = inject(SelectionService);
  productService = inject(ProductService);
  centerService = inject(CenterService);
  target = input.required<'carte_tempo' | 'vitalite'>()
  products = computed(() => {
    const center = this.selectionService.center();
    const target = this.target();
    if (!center) {
      return [];
    }
    return target === 'carte_tempo' ?
      this.productService.reloadTempo() :
      this.productService.reloadVitality();
  });
  protected readonly emulateClick = emulateClick;
}
